import React from "react";
import styled from "@emotion/styled";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faUser,
  faTriangleExclamation,
} from "@fortawesome/free-solid-svg-icons";
import { Guest, Mode } from "../types";

interface GuestItemProps {
  guest: Guest;
  mode?: Mode;
}

const Container = styled.div<{ mode: Mode }>`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: ${({ mode }) => (mode === "dark" ? "0px" : "8px 4px")};
  border-radius: 8px;
`;

const Info = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
`;

const UserIcon = styled.span`
  color: #afabab;
  font-size: 14px;
  display: flex;
  align-items: center;
  @media (min-width: 768px) {
    font-size: 16px;
  }
`;

const Name = styled.span<{ mode: Mode }>`
  font-family: "Rethink-Sans-Medium", "sans-serif";
  font-size: 14px;
  color: ${({ mode }) => (mode === "dark" ? "#fff" : "#000")};
  @media (min-width: 768px) {
    font-size: 16px;
  }
`;

const Phone = styled.span<{ mode: Mode }>`
  font-family: "Rethink-Sans-Regular", "sans-serif";
  font-size: 10px;
  color: ${({ mode }) => (mode === "dark" ? "#fff" : "#4e4e4e")};
  @media (min-width: 768px) {
    font-size: 14px;
  }
`;

const Warning = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 4px;
  color: #e50000;
  font-size: 10px;
  @media (min-width: 768px) {
    font-size: 14px;
  }
`;

const GuestItem: React.FC<GuestItemProps> = ({ guest, mode = "light" }) => {
  return (
    <Container mode={mode}>
      <Info>
        <UserIcon>
          <FontAwesomeIcon icon={faUser} fontSize={14} />
        </UserIcon>
        <Name mode={mode}>
          {guest.first_name} {guest.last_name}
        </Name>
        <Phone mode={mode}>{guest.phone_number}</Phone>
      </Info>
      {!guest.has_active_card && (
        <Warning>
          <FontAwesomeIcon icon={faTriangleExclamation} fontSize={10} />
          <span>No CC on file</span>
        </Warning>
      )}
    </Container>
  );
};

export default GuestItem;
